import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/d3-transition/src/selection/interrupt.js
// module id = 297
// module chunks = 0